import { render } from "./PrivacyAndTermsAgreement.vue?vue&type=template&id=b2c55026&scoped=true"
import script from "./PrivacyAndTermsAgreement.vue?vue&type=script&lang=js"
export * from "./PrivacyAndTermsAgreement.vue?vue&type=script&lang=js"

import "./PrivacyAndTermsAgreement.vue?vue&type=style&index=0&id=b2c55026&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2c55026"]])

export default __exports__